import { Button, Card } from "react-bootstrap"
import { Brand } from "../../App"

import "./actions.css"
import { useState } from "react"
import PublishBrand from "../publish-brand/publish-brand"
import Migration from "../migrate/migrate"
import RebuildCache from "../rebuild-cache/rebuild-cache"
import GlobalPruneOldVersions from "../global-prune-old-versions/global-prune-old-versions"

interface Props {
  runtimeEnv: string
  activeBrand: string
  brands: Brand[]
  trigger: () => void
}

export default function Actions(props: Props) {

  const [showPublishBrand, setShowPublishBrand] = useState(false) // Publish Brand handler
  const [showRebuildCache, setShowRebuildCache] = useState(false) // TODO: Consolidate "show" into a single state var
  const [showGlobalPrune, setShowGlobalPrune] = useState(false)

  // Show migrate handler
  const [showMigrate, setShowMigrate] = useState(false)
  const [migrateTo, setMigrateTo] = useState("")
  const [migrateFrom, setMigrateFrom] = useState("")

  function doMigration(from: string, to: string) {
    setMigrateFrom(from)
    setMigrateTo(to)
    setShowMigrate(true)
  }

  function doCacheRebuild() {
    setShowRebuildCache(true)
  }

  function doGlobalPrune() {
    setShowGlobalPrune(true)
  }

  return (<>
    <div className="header botsep" style={{ textAlign: "center" }}>Actions</div>
    {
      props.activeBrand !== ""
        ? <Card className="action-card">
          <Card.Header>
            Brand Cache
          </Card.Header>
          <Card.Body style={{ textAlign: "center" }}>
            <Button style={{ margin: 4 }} onClick={() => setShowPublishBrand(true)}>Publish Brand Hotels</Button>
          </Card.Body>
        </Card>
        : null}

    <Card className="action-card">
      <Card.Header>
        Global Cache
      </Card.Header>
      <Card.Body style={{ textAlign: "center" }}>
        <Button style={{ margin: 4 }} onClick={() => doGlobalPrune()}>Prune Stale Versions</Button>
        <Button variant="danger" style={{ margin: 4 }} onClick={() => doCacheRebuild()}>Reset Cache</Button>
      </Card.Body>
    </Card>


    <Card className="action-card">
      <Card.Header>
        Migrations
      </Card.Header>
      <Card.Body style={{ textAlign: "center" }}>
        {props.runtimeEnv === "staging" || props.runtimeEnv === "localhost"
          ? <Button style={{ margin: 4 }} onClick={() => doMigration("staging", "live")}>Staging&nbsp;&rarr;&nbsp;Live</Button>
          : null}
        {props.runtimeEnv === "dev" || props.runtimeEnv === "localhost"
          ? <Button style={{ margin: 4 }} onClick={() => doMigration("staging", "dev")}>Staging&nbsp;&rarr;&nbsp;Dev</Button>
          : null}
      </Card.Body>
    </Card>

    <PublishBrand
      brandCode={props.activeBrand}
      brands={props.brands}
      runtimeEnv={props.runtimeEnv}
      show={showPublishBrand}
      onHide={() => {
        props.trigger() // Update cache view TODO: Make this only happen if the publish actually happens...
        setShowPublishBrand(false)
      }}
    />
    <Migration
      from={migrateFrom}
      to={migrateTo}
      show={showMigrate}
      onHide={() => setShowMigrate(false)}
    />
    <RebuildCache
      runtimeEnv={props.runtimeEnv}
      show={showRebuildCache}
      onHide={() => {
        props.trigger()
        setShowRebuildCache(false)
      }}
    />
    <GlobalPruneOldVersions
      runtimeEnv={props.runtimeEnv}
      show={showGlobalPrune}
      onHide={() => {
        props.trigger()
        setShowGlobalPrune(false)
      }}
    />
  </>)
}